import { Endpoint } from "../config";

export type SystemEndpointType =
  | "healthCheck"
  | "systemStatus"
  | "version";

export const systemEndpoints: Record<SystemEndpointType, Endpoint> = {
  healthCheck: {
    url: "health/",
  },
  systemStatus: {
    url: "system/status/",
  },
  version: {
    url: "system/version/",
  },
};